import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { key: 0 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ion_icon = _resolveComponent("ion-icon")!
  const _component_ion_button = _resolveComponent("ion-button")!
  const _component_ion_buttons = _resolveComponent("ion-buttons")!
  const _component_ion_title = _resolveComponent("ion-title")!
  const _component_ion_toolbar = _resolveComponent("ion-toolbar")!
  const _component_ion_grid = _resolveComponent("ion-grid")!
  const _component_ion_header = _resolveComponent("ion-header")!
  const _component_ion_label = _resolveComponent("ion-label")!
  const _component_ion_input = _resolveComponent("ion-input")!
  const _component_ion_item = _resolveComponent("ion-item")!
  const _component_ion_col = _resolveComponent("ion-col")!
  const _component_ion_row = _resolveComponent("ion-row")!
  const _component_ion_select_option = _resolveComponent("ion-select-option")!
  const _component_ion_select = _resolveComponent("ion-select")!
  const _component_ion_content = _resolveComponent("ion-content")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (!_ctx.hideHeader)
      ? (_openBlock(), _createBlock(_component_ion_header, { key: 0 }, {
          default: _withCtx(() => [
            _createVNode(_component_ion_grid, { fixed: "" }, {
              default: _withCtx(() => [
                _createVNode(_component_ion_toolbar, null, {
                  default: _withCtx(() => [
                    (!_ctx.isPage)
                      ? (_openBlock(), _createBlock(_component_ion_buttons, {
                          key: 0,
                          slot: "start"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_button, {
                              slot: "icon-only",
                              onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.closeModal()))
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_icon, { icon: _ctx.arrowBack }, null, 8, ["icon"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }))
                      : _createCommentVNode("", true),
                    _createVNode(_component_ion_title, null, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.t('UserProfilePage.editPersonalInfo')), 1)
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    _createVNode(_component_ion_content, { fullscreen: true }, {
      default: _withCtx(() => [
        _createVNode(_component_ion_grid, { fixed: "" }, {
          default: _withCtx(() => [
            _createElementVNode("form", {
              onSubmit: _cache[10] || (_cache[10] = _withModifiers(($event: any) => (_ctx.updateUser()), ["prevent"]))
            }, [
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { fill: "outline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('fullName')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.newUser.fullName,
                            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.newUser.fullName) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { fill: "outline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('preferredName')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.newUser.preferredName,
                            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.newUser.preferredName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode(_component_ion_col, { size: "6" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { fill: "outline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('chineseName')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            modelValue: _ctx.newUser.chineseName,
                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.newUser.chineseName) = $event))
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_ion_row, null, {
                default: _withCtx(() => [
                  _createVNode(_component_ion_col, { size: "12" }, {
                    default: _withCtx(() => [
                      _createVNode(_component_ion_item, { fill: "outline" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_ion_label, { position: "stacked" }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.t('UserProfilePage.emailAddress')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_ion_input, {
                            inputmode: "email",
                            type: "email",
                            modelValue: _ctx.newUser.email,
                            "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.newUser.email) = $event)),
                            required: ""
                          }, null, 8, ["modelValue"])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              (_ctx.user.isAdmin || _ctx.user.isSecondaryStudent)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "4" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { fill: "outline" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('class')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.newUser.class,
                                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.newUser.class) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_ion_col, { size: "8" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, { fill: "outline" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode(_toDisplayString(_ctx.t('studentNumber')), 1)
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_ion_input, {
                                  modelValue: _ctx.newUser.studentNumber,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.newUser.studentNumber) = $event))
                                }, null, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withCtx(() => [
                        _createVNode(_component_ion_col, { size: "12" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_ion_item, {
                              class: "ion-margin-top",
                              fill: "outline"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => _cache[11] || (_cache[11] = [
                                    _createTextVNode(" What was your rank in your "),
                                    _createElementVNode("b", null, "form", -1),
                                    _createTextVNode(" on the last exam?* ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  interface: "popover",
                                  modelValue: _ctx.newUser.rankInForm,
                                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.newUser.rankInForm) = $event)),
                                  required: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS.rankInForm, (rankRange) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: rankRange,
                                        value: rankRange
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(rankRange), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              class: "ion-margin-top",
                              fill: "outline"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => _cache[12] || (_cache[12] = [
                                    _createTextVNode(" Which elective subject(s) are your studying?* ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  modelValue: _ctx.newUser.studyingElectives,
                                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.newUser.studyingElectives) = $event)),
                                  multiple: ""
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS.electives.sort((a) => (_ctx.newUser.studyingElectives?.includes(a) ? -1 : 0)), (elective) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: elective,
                                        value: elective
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(elective), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_ion_item, {
                              class: "ion-margin-top",
                              fill: "outline"
                            }, {
                              default: _withCtx(() => [
                                _createVNode(_component_ion_label, { position: "stacked" }, {
                                  default: _withCtx(() => _cache[13] || (_cache[13] = [
                                    _createTextVNode(" In which year will you take the HKDSE?* ")
                                  ])),
                                  _: 1
                                }),
                                _createVNode(_component_ion_select, {
                                  interface: "popover",
                                  modelValue: _ctx.newUser.yearDSE,
                                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.newUser.yearDSE) = $event))
                                }, {
                                  default: _withCtx(() => [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.OPTIONS.yearDSE, (year) => {
                                      return (_openBlock(), _createBlock(_component_ion_select_option, {
                                        key: year,
                                        value: year
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode(_toDisplayString(year), 1)
                                        ]),
                                        _: 2
                                      }, 1032, ["value"]))
                                    }), 128))
                                  ]),
                                  _: 1
                                }, 8, ["modelValue"])
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]))
                : _createCommentVNode("", true),
              _createVNode(_component_ion_row),
              _createVNode(_component_ion_button, {
                class: "ion-margin-vertical",
                type: "submit",
                expand: "block"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.t('UserProfilePage.save')), 1)
                ]),
                _: 1
              })
            ], 32)
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ], 64))
}